const env = process.env.APP_ENV || 'development',

    config = {
        sites: {
            nl: {
                name: 'Gladwell Academy',
                short_name: 'gladwell-academy',
                description: 'Gladwell Academy ondersteunt jouw digitale transformatie met trainingen in Agile, Scrum, SAFe, bedrijfsinnovatie en informatiebeheer.',
                siteHandle: 'nl',
                iso: 'nl',
                locale: 'nl',
                currencies: ['EUR', 'USD'],
                group: 'gladwell'
            },
            in: {
                name: 'Gladwell Academy',
                short_name: 'gladwell-academy',
                description: 'Gladwell Academy trains professionals at the intersection of management, IT and innovation. View our Agile & SAFe training portfolio.',
                siteHandle: 'in',
                iso: 'en-IN',
                locale: 'en-IN',
                currencies: ['INR', 'USD'],
                group: 'gladwell'
            },
            en: {
                name: 'Gladwell Academy',
                short_name: 'gladwell-academy',
                description: 'Gladwell Academy trains professionals at the intersection of management, IT and innovation. View our Agile & SAFe training portfolio.',
                siteHandle: 'en',
                iso: 'en',
                locale: 'en',
                currencies: ['EUR', 'USD'],
                group: 'gladwell'
            },
            de: {
                name: 'Gladwell Academy',
                short_name: 'gladwell-academy',
                description: '',
                siteHandle: 'de',
                iso: 'de',
                locale: 'de',
                currencies: ['EUR', 'USD'],
                group: 'gladwell'
            },
            fr: {
                name: 'Gladwell Academy',
                short_name: 'gladwell-academy',
                description: '',
                siteHandle: 'fr',
                iso: 'fr',
                locale: 'fr',
                currencies: ['EUR', 'USD'],
                group: 'gladwell'
            },
            highbergEN: {
                name: 'Highberg',
                short_name: 'highberg',
                description: '',
                siteHandle: 'highbergEN',
                iso: 'en',
                locale: 'en-Highberg',
                currencies: ['EUR', 'USD'],
                group: 'highberg'
            },
            highbergNL: {
                name: 'Highberg',
                short_name: 'highberg',
                description: '',
                siteHandle: 'highbergNL',
                iso: 'nl',
                locale: 'nl-Highberg',
                currencies: ['EUR'],
                group: 'highberg'
            },
            highbergDE: {
                name: 'Highberg',
                short_name: 'highberg',
                description: '',
                siteHandle: 'highbergDE',
                iso: 'de',
                locale: 'de-Highberg',
                currencies: ['EUR'],
                group: 'highberg'
            }
        }
    },

    localizedConfigs = {
        production: require('./production').default,
        staging: require('./staging').default,
        development: require('./development').default
    },

    localizedConfig = localizedConfigs[env];

export function getSiteConfig(handle) {
    if (config.sites[handle]) {
        return config.sites[handle];
    }

    throw new Error('Could not find a matching site. Make sure you have provide a valid APP_MULTISITE_HANDLE env-variable.');
}

export default Object.assign(config, localizedConfig);
